import { NgModule } from '@angular/core';
import { CrmAppConfig } from 'common-module/core';

import { appConfig } from './app.config';
import { LoginFormProvider } from './providers/login-form.provider';

@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    LoginFormProvider,
    {
      provide: CrmAppConfig,
      useValue: appConfig
    }
  ]
})
export class ConfigurationModule {}
